import {Header} from '@/components/commons/header/Header'
import {Divider} from '@/components/ui/divider/Divider'
import {PageBody} from '@/components/ui/page-atoms/PageAtoms'
import {Outlet} from 'react-router-dom'
import {StyledAccessesRoute} from './style'
import {usePermissions} from '@/features/auth/store/store'

import {NoPermissionBox} from '@/components/commons/no-permission-box/NoPermissionBox'

export const AccessesRoute = () => {
    const permissions = usePermissions()

    if (!permissions?.accesses?.read) {
        return <NoPermissionBox />
    }

    return (
        <PageBody>
            <Header />
            <Divider direction="horizontal" />
            <StyledAccessesRoute>
                <Outlet />
            </StyledAccessesRoute>
        </PageBody>
    )
}
